import { render } from "./WeekOrders.vue?vue&type=template&id=0f96c640"
import script from "./WeekOrders.vue?vue&type=script&lang=ts"
export * from "./WeekOrders.vue?vue&type=script&lang=ts"
script.render = render

export default script